/* LOGO SCROLLER */
document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.logolist--inner');
  if (!container || container.dataset.cloned === 'true') return;

  const NORMAL_SPEED = 1.2;
  const SLOW_SPEED = 0.25;
  const STOP_SPEED = 0;
  let scrollX = 0;
  let speed = NORMAL_SPEED;
  let targetSpeed = NORMAL_SPEED;
  let isStopped = false;

  function animate() {
    scrollX -= speed;
    container.style.transform = `translateX(${scrollX}px)`;

    const containerWidth = container.scrollWidth / 2;
    if (Math.abs(scrollX) >= containerWidth) scrollX = 0;

    speed += (targetSpeed - speed) * 0.1;
    requestAnimationFrame(animate);
  }

  function cloneItems() {
    const items = Array.from(container.children).filter(el =>
      el.querySelector('img, svg')
    );
    items.forEach(item => {
      const clone = item.cloneNode(true);
      container.appendChild(clone);
    });
    container.dataset.cloned = 'true';
  }

  function startWhenImagesReady() {
    const images = container.querySelectorAll('img');
    let loadedCount = 0;

    function start() {
      if (!container.dataset.cloned) {
        cloneItems();
        animate();
      }
    }

    if (images.length === 0) return start();

    images.forEach(img => {
      if (img.complete) {
        loadedCount++;
      } else {
        img.addEventListener('load', () => {
          loadedCount++;
          if (loadedCount === images.length) start();
        });
        img.addEventListener('error', () => {
          loadedCount++;
          if (loadedCount === images.length) start();
        });
      }
    });

    if (loadedCount === images.length) start();

    setTimeout(start, 2000);
  }

  function initScrollOnView() {
    const observer = new IntersectionObserver((entries, obs) => {
      if (entries[0].isIntersecting) {
        obs.disconnect();
        startWhenImagesReady();

        if ('ontouchstart' in window === false) {
          container.addEventListener('mouseenter', () => {
            if (!isStopped) targetSpeed = SLOW_SPEED;
          });
          container.addEventListener('mouseleave', () => {
            if (!isStopped) targetSpeed = NORMAL_SPEED;
          });
          container.addEventListener('click', () => {
            if (isStopped) {
              isStopped = false;
              targetSpeed = NORMAL_SPEED;
            } else {
              isStopped = true;
              targetSpeed = STOP_SPEED;
            }
          });
        }
      }
    }, {
      threshold: 0,
      rootMargin: '0px 0px -50px 0px'
    });

    observer.observe(container);
  }

  initScrollOnView();
});

/* Testimonials slider */

// Dynamic Testimonials - DynamicTestimonials in empire.js has some breakpoints set, but no need to change if we have 3 testimonials or more.

//forms customization

document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('#app-embed');

  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector('#app-embed');

    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;

      const sheet = new CSSStyleSheet();
      sheet.insertRule(`
        
        section > section > div._gridItem_1q1d2_172._gridItemContent_1q1d2_257 > section > h2 {
          font-size: 2rem !important; 
          margin-bottom: 15px !important;
        }

        `);
      sheet.insertRule(`
        
        section > section > div._gridItem_1q1d2_172._gridItemContent_1q1d2_257 > section > div {
          font-size: 1.3rem !important;
        }

        `);


        

      shadow.adoptedStyleSheets.push(sheet);
      formContainer.classList.add('loaded');
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})
